import React from 'react';
import type { OvernightConfig } from '@/types';
import { HourlyPremiumSection } from '../../shared/HourlyPremiumSection';


interface Props {
  config: OvernightConfig;
  onConfigChange: (updates: Partial<OvernightConfig>) => void;
  premiumValueProps?: Record<string, unknown>;
  premiumValueError?: React.ReactNode;
  customizedFields: Record<string, boolean>;
  context: 'user' | 'client';
  firstOvertimeMultiplierName: string;
}

export const HourlyPremiumMethodSection: React.FC<Props> = ({
  config,
  onConfigChange,
  premiumValueProps,
  premiumValueError,
  customizedFields,
  context,
  firstOvertimeMultiplierName,
}) => {
  return (
    <div>
      <HourlyPremiumSection
          config={config}
          onConfigChange={onConfigChange}
          premiumValueProps={premiumValueProps}
          premiumValueError={premiumValueError}
          customizedFields={customizedFields}
          context={context}
        />
    </div>
  );
};
